

import { MediaMatcher } from '@angular/cdk/layout';
import {ChangeDetectorRef, Component,OnDestroy,AfterViewInit, ViewChild} from '@angular/core';
import { environment } from 'src/environments/environment';
import { MatSidenav } from '@angular/material/sidenav';

/** @title Responsive sidenav */

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.css'],
    standalone: false
})

export class LayoutComponent implements OnDestroy, AfterViewInit {
  mobileQuery: MediaQueryList;
  /** True = narrow icon-only sidebar rail. Owned here since it also drives
   * the mat-drawer's width. */
  sidebarCollapsed: boolean = false;
  private _mobileQueryListener: () => void;
  @ViewChild('snav') sidenav: MatSidenav;

  envColor : string = "";
  envTextColor : string = "";
  environment : string = "";

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    const baseURL = environment.baseURL;
    if (environment.production == false) {
      if (baseURL.includes('dev')) {
        this.environment = 'DEV MODE';
        this.envColor = "#B5EEE8"
        this.envTextColor = "#39AE86"

      } else if (baseURL.includes('qa')) {
        this.environment = 'QA MODE';
        this.envColor = "#F7DAC6"
        this.envTextColor = "#E19259"

      } else if (baseURL.includes('staging')) {
        this.environment = 'UAT MODE';
        this.envColor = "#F6DFFD"
        this.envTextColor = "#B480C4"
      }
    }
    console.log('Environment set to:', this.environment);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  ngAfterViewInit() {}
}
